export function initAccordions() {
    const accordions = [...document.querySelectorAll('.rb-accordion')]
    accordions.forEach(initAccordionInstance);
}

export function initAccordionInstance(root) {
    const questions = root.querySelectorAll('.-question');

    [].slice.call(questions).forEach((question) => {
        const answer = question.nextElementSibling;

        question.addEventListener('click', () => {
            const button = question.querySelector("button");
            if (question.classList.contains("is--active")) {
                button.setAttribute("aria-expanded", "false");
                button.setAttribute("aria-label", "Visa svar");
            } else {
                button.setAttribute("aria-expanded", "true");
                button.setAttribute("aria-label", "Dölj svar");
            }

            jQuery(question).toggleClass('is--active');
            jQuery(answer).slideToggle(200);
        })
    })
}
